import React from 'react';
import Container from 'Nori/Container';
import Card from 'Custom/Card/BasicCard';
import styles from 'Custom/CardsBlock/index.module.scss';

const CardsBlock = ({ className = '', cards = [], ...props }) => (
  <div className={`${styles.enrollmentWrapper} ${className}`} {...props}>
    <Container className={styles.cardsContainer}>
      {Boolean(cards.length) && (
        <div className={styles.cardList}>
          {cards.map((card, index) => (
            <Card
              key={`card-${index}`}
              type="enrollment"
              className={styles.cardItem}
              {...card}
            />
          ))}
        </div>
      )}
    </Container>
  </div>
);

export default CardsBlock;
